import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=05634ca8&lang=pug&"
import script from "./historyModal.vue?vue&type=script&lang=js&"
export * from "./historyModal.vue?vue&type=script&lang=js&"
import style0 from "./historyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports